export type DepartmentPermissionsIds = 'erp:invoicing:enabled'

export type DepartmentPermissions = {
  id: DepartmentPermissionsIds
  name: string
  description: string
}

export const ERP_INVOICING_PERMISSION: DepartmentPermissions = {
  id: 'erp:invoicing:enabled',
  name: 'Módulo de facturación',
  description: 'Permite la integración con el módulo de facturación de ERP.',
}

export const DEPARTMENT_PERMISSIONS: DepartmentPermissions[] = [
  ERP_INVOICING_PERMISSION,
]
